import { Link } from "react-router-dom"
import type { DashboardCard } from "../api/types.ts"
import { useApiQuery } from "../hooks/index.ts"
import { useI18n } from "../i18n/index.tsx"

/** 제목 옆에 붙는 요약. 세 칸을 넘기면 한 줄에 안 들어가고 눈에도 안 들어온다. */
const MAX_CARDS = 3

/**
 * "지금 이 목록이 어떤 상황인가"를 제목 아래 한 줄로.
 *
 * 숫자는 대시보드와 **같은 API**(`/api/dashboard`)에서 온다 — 목록 화면이 따로 세면
 * 대시보드는 3건인데 목록 머리에는 5건이 되는 일이 생긴다. 누르면 그 조건으로 걸러진다.
 */
export function CaseSummary({ total }: { total: number | null }) {
  const { t } = useI18n()
  const query = useApiQuery<{ cards: DashboardCard[] }>("/api/dashboard")

  // 할 일이 없는 카드(0건)는 굳이 자리를 차지하지 않는다.
  const cards = (query.data?.cards ?? []).filter((card) => card.count > 0).slice(0, MAX_CARDS)

  return (
    <>
      <span className="summary-chip summary-chip--plain">
        {t("cases.filterAll")} <strong>{total ?? "—"}</strong>
      </span>
      {cards.map((card) => (
        <Link key={card.key} className="summary-chip" to={`/cases?card=${card.key}`}>
          {t(`card.${card.key}`)} <strong>{card.count}</strong>
        </Link>
      ))}
    </>
  )
}
